import PiSpinnerStroke from "@markeroo/icons/src/stroke/general/PiSpinnerStroke";

type SpinnerSize = "sm" | "md" | "lg" | "xl";

interface SpinnerProps {
  /** Size of the spinner */
  size?: SpinnerSize;
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
  xl: "h-12 w-12",
};

/**
 * Reusable loading spinner component using PiSpinnerStroke icon.
 *
 * @example
 * <Spinner />
 * <Spinner size="lg" />
 * <Spinner size="sm" className="text-brand-600" />
 */
export function Spinner({ size = "md", className = "" }: SpinnerProps) {
  return (
    <PiSpinnerStroke
      className={`animate-spin ${sizeClasses[size]} ${className}`}
      aria-hidden="true"
    />
  );
}
